import * as Sentry from '@sentry/react';
import { AlertTriangle } from 'lucide-react';
import { SectionCard } from './ui/SectionCard';
import { ErrorAlert } from './ui/ErrorAlert';

function ErrorFallback({ error, resetError }: { error: Error; resetError: () => void }) {
  return (
    <div className="min-h-screen flex items-start justify-center pt-20 px-4">
      <div className="w-full max-w-lg">
        <SectionCard title="Something went wrong">
          <ErrorAlert label="An unexpected error occurred" message={error.message} />
          <button
            onClick={resetError}
            className="mt-4 inline-flex items-center gap-2 px-4 py-2 bg-brand-500 hover:bg-brand-600 text-white text-sm font-semibold rounded-lg transition-colors"
          >
            <AlertTriangle className="h-4 w-4" />
            Try again
          </button>
        </SectionCard>
      </div>
    </div>
  );
}

export function AppErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <ErrorFallback error={error as Error} resetError={resetError} />
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
